var path = 'entity/entity-filter-view.tpl.html';
var html = "\n<div layout='column' class=\"tb-entity-filter-view\">\n    <div ng-if=\"!filter || !filter.type\" class=\"entity-filter-empty\" translate>alias.no-entity-filter-specified</div>\n    <div ng-if=\"filter && filter.type\" layout=\"column\">\n        <div class=\"entity-filter-value\">{{ filterDisplayValue }}</div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-filter-view.tpl.html
// module id = 1466
// module chunks = 1